import type { Site, Multigroup, RecordEntityId } from '@centric-os/types';

export default () => {
  /**
   * Maps site form values to ensure consistency before submission.
   *
   * @param {Partial<Site>} formValues - The site data to be mapped.
   */
  const mapSite = (formValues: Partial<Site>): Partial<Site> => {
    return {
      address: {
        state: formValues.address?.state,
        zip: formValues.address?.zip,
        country: formValues.address?.country,
        address: formValues.address?.address,
        city: formValues.address?.city,
        coordinates: {
          latitude: formValues.address?.coordinates?.latitude,
          longitude: formValues.address?.coordinates?.longitude,
        },
      },
      label: {
        en: formValues.name,
      },
      meta: {
        sector_name: formValues.meta?.sector_name,
      },
      name: formValues.name,
    };
  };
  /**
   * Maps site form values to multigroup to ensure consistency before submission.
   * If no multigroup is provided (integration-agnostic mode), uses the Unlisted multigroup.
   *
   * @param {Partial<Site>} formValues - The site data to be mapped.
   * @param {RecordEntityId} siteId - The ID of the created site.
   */
  const mapMultigroup = (
    formValues: Partial<Site>,
    siteId: RecordEntityId,
  ): Partial<Multigroup> => {
    // Use Unlisted multigroup if no integration was selected
    const multigroupId = formValues.multigroup || import.meta.env.VITE_UNLISTED_MULTIGROUP;

    return {
      id: multigroupId,
      groups: [
        {
          id: siteId,
        },
      ],
    };
  };

  return { mapSite, mapMultigroup };
};
